/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import { TouchableOpacity, ScrollView, View } from "react-native";
import { LogoutModal, BackButton, FadeInOutView, Text } from "UpduoLibrary";
import { useDispatch } from "react-redux";

import {
  skalePrimaryBlue,
  skaleRed,
  skaleWhite,
  skaleWebBackgroundGray,
  skaleWebTextGray,
} from "config/UpduoColors";
import { instantiateMemberUser } from "config/ResetState";
import { ActionCreators } from "actions";
import AccountSettings from "./AccountSettings";
import DeactivateSettings from "./DeactivateSettings";
import DeactivateModal from "./DeactivateModal";
import PhotoModal from "UpduoLibrary/PhotoModal";

import Icon from "react-icons-kit";
import { chevronRight } from "react-icons-kit/fa/chevronRight";

import * as UpduoAnalytics from "config/UpduoAnalytics";

export default function SettingsRoute({ history }) {
  const [currentSubpage, setCurrentSubpage] = useState("Account");
  const [logoutModalVisible, setLogoutModalVisible] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [deactivateModal, setDeactivateModal] = useState("none");
  const settingsSubpages = {
    Account: (
      <AccountSettings onShowPhotoModal={() => setShowPhotoModal(true)} />
    ),
    "Advanced Options": (
      <DeactivateSettings setActiveModal={setDeactivateModal} />
    ),
  };

  const dispatch = useDispatch();

  const _handleSuccessfulSubmission = () => {
    // Add delay for latest photoSubmitSuccessCounter value
    setTimeout(() => {
      // Submission is successful only if both small and large formats are uploaded
      dispatch(ActionCreators.setProfilePicSet(true));
    }, 500);
    setShowPhotoModal(false);
    instantiateMemberUser();
  };

  return (
    <>
      <FadeInOutView
        style={{
          flex: 1,
          margin: 60,
          borderWidth: 0,
          borderStyle: undefined,
          backgroundColor: skaleWhite,
          borderRadius: 12,
          alignItems: "stretch",
          flexDirection: "row",
          minHeight: 600,
        }}
      >
        <View style={{ top: -40, position: "absolute" }}>
          <BackButton
            onPress={() => {
              UpduoAnalytics.logEvent("user-settings-back");
              history.goBack();
            }}
          />
        </View>
        <View
          style={{
            width: 360,
            paddingVertical: 32,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <View>
            <Text
              isHeading={true}
              style={{
                fontSize: 24,
                marginBottom: 60,
                paddingLeft: 60,
              }}
            >
              {"Settings"}
            </Text>
            {Object.keys(settingsSubpages).map((pageName) => {
              return (
                <View
                  style={{
                    borderBottomWidth: 1,
                    borderColor: skaleWebBackgroundGray,
                    marginLeft: 32,
                    paddingHorizontal: 28,
                  }}
                >
                  <TouchableOpacity
                    onPress={() => setCurrentSubpage(pageName)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "row",
                      marginVertical: 20,
                      width: "100%",
                    }}
                  >
                    <Text
                      style={{
                        color:
                          pageName === currentSubpage
                            ? skalePrimaryBlue
                            : skaleWebTextGray,
                        fontSize: 16,
                      }}
                      isHeading={pageName === currentSubpage}
                    >
                      {pageName}
                    </Text>
                    <Icon
                      style={{
                        color:
                          pageName === currentSubpage
                            ? skalePrimaryBlue
                            : skaleWebTextGray,
                      }}
                      size={12}
                      icon={chevronRight}
                    />
                  </TouchableOpacity>
                </View>
              );
            })}
          </View>
          <View
            style={{
              marginLeft: 60,
            }}
          >
            <TouchableOpacity
              onPress={() => {
                UpduoAnalytics.logEvent("user-settings-logout");
                setLogoutModalVisible(true);
              }}
            >
              <Text
                style={{
                  marginTop: 10,
                  marginBottom: 10,
                  width: 60,
                  color: skaleRed,
                  fontSize: 16,
                }}
              >
                {"Log Out"}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
        <ScrollView
          horizontal={true}
          style={{
            borderLeftWidth: 1,
            borderColor: skaleWebBackgroundGray,
            padding: 32,
          }}
        >
          {settingsSubpages[currentSubpage]}
        </ScrollView>
      </FadeInOutView>
      <LogoutModal
        isVisible={logoutModalVisible}
        onClose={() => {
          setLogoutModalVisible(false);
        }}
      />
      <PhotoModal
        isVisible={showPhotoModal}
        onDismiss={() => setShowPhotoModal(false)}
        updatePhoto={_handleSuccessfulSubmission}
        userHasPhoto={true}
      />
      <DeactivateModal
        isVisible={deactivateModal !== "none"}
        onClose={() => {
          setDeactivateModal("none");
        }}
        deactivate={deactivateModal === "deactivate"}
      />
    </>
  );
}
